import { getLocalizedValue } from './transformersUtils';

export const transformTitleTextToID = (localizedValue: unknown | Text): string =>
  getLocalizedValue(localizedValue)?.split(' ').join('_').toLowerCase();
